import Link from 'next/link';

import { Tooltip, Text } from '@backyard-ui/core';

import { styles } from './Variant.styles';

type ItemProps = {
  label: string;
  url: string;
  isActive: boolean;
  isDisabled: boolean;
};

function Variant(props: Readonly<ItemProps>) {
  const { label, url, isActive, isDisabled } = props;

  const classNames = styles({ isActive, isDisabled });

  if (isDisabled) {
    return (
      <Tooltip.Provider>
        <Tooltip.Root>
          <Tooltip.Trigger>
            <div className={classNames.base()}>
              <Text
                UNSAFE_className={classNames.link()}
                data-is-disabled={isDisabled}
              >
                {label}
              </Text>
            </div>
          </Tooltip.Trigger>
          <Tooltip.Content>Indisponível</Tooltip.Content>
        </Tooltip.Root>
      </Tooltip.Provider>
    );
  }

  return (
    <div className={classNames.base()} data-gtm-element="Variant Button">
      <Link href={url} className={classNames.link()} data-is-active={isActive}>
        {label}
      </Link>
    </div>
  );
}

export default Variant;
